module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content fadeInRight animated tabBox",
    attrs: {
      "id": "carfile-list"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车辆ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryParam.vehicleId),
      expression: "queryParam.vehicleId",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.queryParam.vehicleId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryParam, "vehicleId", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("服务卡号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryParam.vehicleAccount),
      expression: "queryParam.vehicleAccount",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.queryParam.vehicleAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryParam, "vehicleAccount", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("起始时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    class: {
      'form-group--error': !_vm.validDates
    }
  }, [_c('datepicker', {
    ref: "dateFrom",
    staticClass: "form-control",
    model: {
      value: (_vm.queryParam.serviceTimeBegin),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "serviceTimeBegin", $$v)
      },
      expression: "queryParam.serviceTimeBegin"
    }
  }), _vm._v(" "), (!_vm.validDates) ? _c('p', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("开始时间不得大于结束时间")]) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    class: {
      'form-group--error': !_vm.validDates
    }
  }, [_c('datepicker', {
    ref: "dateTo",
    staticClass: "form-control",
    model: {
      value: (_vm.queryParam.serviceTimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "serviceTimeEnd", $$v)
      },
      expression: "queryParam.serviceTimeEnd"
    }
  }), _vm._v(" "), (!_vm.validDates) ? _c('p', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("开始时间不得大于结束时间")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车牌号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('vplate-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "9"
    },
    model: {
      value: (_vm.queryParam.plateNumber),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "plateNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryParam.plateNumber"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("当前位置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryParam.address),
      expression: "queryParam.address",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.queryParam.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryParam, "address", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车主")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryParam.vehicleOwnerName),
      expression: "queryParam.vehicleOwnerName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.queryParam.vehicleOwnerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryParam, "vehicleOwnerName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryParam.phone),
      expression: "queryParam.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.queryParam.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryParam, "phone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车辆分支")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryGroup),
      expression: "queryGroup"
    }],
    staticClass: "form-control menuInput",
    attrs: {
      "type": "text",
      "id": "group_list",
      "autocomplete": "off",
      "disableautocomplete": ""
    },
    domProps: {
      "value": (_vm.queryGroup)
    },
    on: {
      "focus": _vm.showMenu,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryGroup = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("设备编号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryParam.deviceNum),
      expression: "queryParam.deviceNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.queryParam.deviceNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.queryParam, "deviceNum", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [(_vm.permission.indexOf('fileCarList_download') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": _vm.openDownload
    }
  }, [_vm._v("下载")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('fileCarList_upload') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": _vm.openFileUpload
    }
  }, [_vm._v("上传")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.removeVehicle
    }
  }, [_vm._v("删除")]), _vm._v(" "), (_vm.permission.indexOf('fileCarList_reset') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.resetQueryParams
    }
  }, [_vm._v("重置")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('fileCarList_select') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": _vm.searchInfo
    }
  }, [_vm._v("查询")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('fileCarList_changeToTest') == -1) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": function($event) {
        return _vm.turnformalCar(1)
      }
    }
  }, [_vm._v("正式车降级成测试车")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('fileCarList_changeToFormal') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": function($event) {
        return _vm.turnformalCar(2)
      }
    }
  }, [_vm._v("测试车升级成正式车")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list-complete",
      "tag": "tbody"
    }
  }, _vm._l((_vm.fileInfoList), function(fileInfo, index) {
    return _c('tr', {
      key: index + 'filecar',
      staticClass: "list-complete-item"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.vehicleSelectArr),
        expression: "vehicleSelectArr"
      }],
      staticStyle: {
        "margin-top": "0px"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": fileInfo.vehicleId,
        "checked": Array.isArray(_vm.vehicleSelectArr) ? _vm._i(_vm.vehicleSelectArr, fileInfo.vehicleId) > -1 : (_vm.vehicleSelectArr)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.vehicleSelectArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = fileInfo.vehicleId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.vehicleSelectArr = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.vehicleSelectArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.vehicleSelectArr = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v("VE" + _vm._s(fileInfo.vehicleId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.deviceNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.vehicleAccount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.groupName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.serviceEndTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.vehicleTypeSerie))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.plateNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.startSaleTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.vehicleOwnerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.isTestCar == 0 ? '正式车' : '测试车'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.insuranceNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.permission.indexOf('fileCarList_detail') == -1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.addTab(fileInfo.plateNumber, fileInfo.vehicleId)
        }
      }
    }, [_vm._v("详情")]) : _vm._e()])])
  }), 0)], 1)]), _vm._v(" "), (_vm.fileInfoList.length > 0) ? _c('pagination', {
    attrs: {
      "pageInfo": _vm.pageInfo
    },
    on: {
      "getData": _vm.getPageNo
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sub-page', {
    attrs: {
      "show": _vm.toShow,
      "bigTitleMsg": _vm.bigTitle,
      "scroll": _vm.scrollTop
    },
    on: {
      "cancel": _vm.handleSubPage
    }
  }, [_c('div', {
    attrs: {
      "slot": "bodycontent"
    },
    slot: "bodycontent"
  }, [(_vm.toShow) ? _c('file-upload', {
    on: {
      "cancel": _vm.handleSubPage
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('sub-page', {
    attrs: {
      "show": _vm.toDownShow,
      "bigTitleMsg": _vm.bigTitle,
      "scroll": _vm.scrollTop
    },
    on: {
      "cancel": _vm.handleDownSubPage
    }
  }, [_c('div', {
    attrs: {
      "slot": "bodycontent"
    },
    slot: "bodycontent"
  }, [(_vm.toDownShow) ? _c('file-download', {
    on: {
      "cancel": _vm.handleDownSubPage
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('main-modal', {
    ref: "modalAdmin",
    attrs: {
      "size": "normal",
      "title": "正式车降级为测试车"
    },
    on: {
      "close": _vm.closeAdmin
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('div', [_c('label', {
    staticClass: "col-sm-1 control-label t_center red"
  }, [_vm._v("理由")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticClass: "col-sm-11",
    attrs: {
      "rows": "6",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary text-center",
    on: {
      "click": function($event) {
        return _vm.confirform()
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.messageStr) + "\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modal2",
    attrs: {
      "size": "small",
      "title": "提示",
      "scroll": _vm.scrollTop
    },
    on: {
      "cancel": function($event) {
        return _vm.closeModal('modal2')
      }
    }
  }, [_vm._v("\n\t\t确定删除所选车辆？\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal('modal2')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.removeItem()
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalformalCar",
    attrs: {
      "size": "small",
      "title": "提示",
      "scroll": _vm.scrollTop
    },
    on: {
      "cancel": function($event) {
        return _vm.closeModal('modalformalCar')
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.messageStr) + "\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal('modalformalCar')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirformalCar()
      }
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menuContent",
    staticStyle: {
      "display": "none",
      "position": "absolute"
    },
    attrs: {
      "id": "menuContentF"
    }
  }, [_c('ul', {
    staticClass: "ztree ztree-slide",
    staticStyle: {
      "margin-top": "0",
      "width": "250px",
      "height": "300px"
    },
    attrs: {
      "id": "carOrgTree"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("车辆ID")]), _vm._v(" "), _c('th', [_vm._v("设备编号")]), _vm._v(" "), _c('th', [_vm._v("服务卡号")]), _vm._v(" "), _c('th', [_vm._v("所属分支")]), _vm._v(" "), _c('th', [_vm._v("服务结束日")]), _vm._v(" "), _c('th', [_vm._v("车型车系")]), _vm._v(" "), _c('th', [_vm._v("车牌号")]), _vm._v(" "), _c('th', [_vm._v("车牌登记日")]), _vm._v(" "), _c('th', [_vm._v("当前位置")]), _vm._v(" "), _c('th', [_vm._v("车主")]), _vm._v(" "), _c('th', [_vm._v("联系方式")]), _vm._v(" "), _c('th', [_vm._v("车辆类型")]), _vm._v(" "), _c('th', [_vm._v("设备保单号")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503a7198","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didicarfile/PageFileCarList.vue
// module id = 1509
// module chunks = 0